import { sortBy } from "lodash";
import React, { useState } from "react";

import { reactKeyFromIDSK } from "@examspark/common";
import {
  AnalyticsEventName,
  NewClassroomModal,
  useAnalytics,
} from "@examspark/common-app";
import { IconAddLine } from "@examspark/common-ui/dist/components/icons";
import { UserClassroom } from "@examspark/types";

import { SectionGrid } from "../dashboard/Dashboard";
import SectionBox, { NewSectionBox } from "../dashboard/SectionBox";

const ClassroomsGrid = (props: {
  sections?: UserClassroom[];
  allowCreateSection?: boolean;
  onCreate?: () => void;
}) => {
  const [isNewSectionModalOpen, setIsNewSectionModalOpen] = useState(false);
  const analytics = useAnalytics();

  return (
    <>
      <NewClassroomModal
        isOpen={isNewSectionModalOpen}
        onRequestClose={() => setIsNewSectionModalOpen(false)}
        onCreate={() => {
          setIsNewSectionModalOpen(false);
          analytics.trackEvent(AnalyticsEventName.ClassroomCreate);
          props.onCreate?.();
        }}
        hideCourseInput={false}
        hideSubjectInput={false}
        hideGradeInput={false}
      />
      <SectionGrid>
        {sortBy(props.sections, ["classroom.name"])?.map(
          (section) =>
            section?.classroom && (
              <SectionBox
                key={reactKeyFromIDSK(section.classroom)}
                userClassroom={section}
                to={`/classroom/${section.classroom.id}`}
              />
            ),
        )}
        {props.allowCreateSection && (
          <NewSectionBox onClick={() => setIsNewSectionModalOpen(true)}>
            <IconAddLine width="24" />
            <div>Add New Classroom</div>
          </NewSectionBox>
        )}
      </SectionGrid>
    </>
  );
};

export default ClassroomsGrid;
